import { RouteLocationNormalized } from "vue-router";
import { useEventbus } from "@/core";
import {bindEmitter} from "@/utils/emitter"
export type RouteItem = Partial<RouteLocationNormalized> & {
  fullPath: string;
  name: string;
  cachedFullPath: string;
};

export enum TabEventEnum {
  CLOSE_CURRENT_TAB = "CLOSE_CURRENT_TAB",
  CLOSE_LEFT_TABS = "CLOSE_LEFT_TABS",
  CLOSE_RIGHT_TABS = "CLOSE_RIGHT_TABS",
  CLOSE_OTHER_TABS = "CLOSE_OTHER_TABS",
  CLOSE_ALL_TABS = "CLOSE_ALL_TABS",
}
const closeCurrentTabEventEmit = bindEmitter(TabEventEnum.CLOSE_CURRENT_TAB);
const closeLeftTabEventEmit = bindEmitter(TabEventEnum.CLOSE_LEFT_TABS);
const closeRightTabEventEmit = bindEmitter(TabEventEnum.CLOSE_RIGHT_TABS);
const closeOtherTabEventEmit = bindEmitter(TabEventEnum.CLOSE_OTHER_TABS);
const closeAllTabEventEmit = bindEmitter(TabEventEnum.CLOSE_ALL_TABS);
export class TabService {
  static closeCurrentTab() {
    // const { customEmit } = useEventbus();
    closeCurrentTabEventEmit(TabEventEnum.CLOSE_CURRENT_TAB);
  }

  static closeLeftTabs() {
    // const { customEmit } = useEventbus();
    closeLeftTabEventEmit(TabEventEnum.CLOSE_LEFT_TABS);
  }

  static closeRightTabs() {
    // const { customEmit } = useEventbus();
    closeRightTabEventEmit(TabEventEnum.CLOSE_RIGHT_TABS);
  }

  static closeOtherTabs() {
    // const { customEmit } = useEventbus();
    closeOtherTabEventEmit(TabEventEnum.CLOSE_OTHER_TABS);
  }

  static closeAllTabs() {
    // const { customEmit } = useEventbus();
    closeAllTabEventEmit(TabEventEnum.CLOSE_ALL_TABS);
  }
}
